import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { actions as userActions } from "../../../../redux/modules/user";
import YearSelect from "./components/YearSelect";
import Success from "./components/Success";
import "./style.css";
import "../../../../index.css";
import { post, get } from "../../../../utils/request";
import { getQueryValue } from "../../../../utils/tool";
class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phone: "",
      code: "",
      password: "",
      year: "",
      error_phone_visible: false,
      error_visible: false,
      error_info: "",
      error_btn: true,
      code_name: "获取验证码",
      yztime: 59,
      loading: false,
      prevPath: "/",
      ysVisible: false,
      shown: false,
      success_visible: false,
      // 图形验证码相关
      imgCode: "",
      imgCodeUrl: "",
      imgCodeVisible: false,
    };
  }
  componentDidMount() {
    if (getQueryValue("phone") != null) {
      this.setState({
        phone: getQueryValue("phone"),
        prevPath: getQueryValue("prevPath"),
      });
    }
  }
  render() {
    return (
      <div>
        <div className="register_img">
          <img
            alt=""
            src={require("../../../../images/user/register.png")}
          ></img>
        </div>
        <div className="register_box">
          <div className="register_phone">
            <input
              type="text"
              onChange={this.handlePhoneChang}
              value={this.state.phone}
              placeholder="请输入手机号"
            ></input>
          </div>
          <div className="register_code">
            <input
              type="text"
              onChange={this.handleCodeChang}
              value={this.state.code}
              className="fl"
              placeholder="短信验证码"
            ></input>
            <div
              onClick={() => this.requestSms()}
              style={
                this.state.loading === true
                  ? { backgroundColor: "#f1f1f1", color: "#5d5d5d" }
                  : { backgroundColor: "#ff5900" }
              }
              className="register_code_btn fr"
            >
              {this.state.code_name}
            </div>
          </div>
          <div className="register_password">
            <input
              onChange={this.handlePasswordChang}
              value={this.state.password}
              type={this.state.shown ? "text" : "password"}
              className="fl"
              placeholder="请输入新密码 （6-18位）"
            ></input>
            <img
              onClick={() => {
                this.setState({
                  shown: !this.state.shown,
                });
              }}
              alt=""
              src={
                this.state.shown
                  ? require("../../../../images/user/visible.png")
                  : require("../../../../images/user/invisible.png")
              }
            ></img>
          </div>
          <div
            onClick={() => this.handleShowYearSelect()}
            className="register_year"
          >
            <input
              type="text"
              value={this.state.year}
              className={
                this.state.year === ""
                  ? "fl disabled_inactive"
                  : "fl disabled_active"
              }
              placeholder="高考年份"
            ></input>
          </div>
          <div onClick={() => this.requestRegister()} className="register_btn">
            注 册
          </div>
        </div>
        <div className="register_problem">
          <span>注册有问题？</span>
          <span className="register_problem_contact">
            <a href="tel:13067852167">联系我们</a>
          </span>
        </div>
        <div
          style={
            this.state.error_phone_visible === true
              ? { display: "block" }
              : { display: "none" }
          }
          className="register_error"
        >
          <div className="register_modal">
            <img
              alt=""
              src={require("../../../../images/user/notice.png")}
            ></img>
            <div>
              <p>该手机号已注册</p>
              <p>请登陆或更换手机号注册</p>
            </div>
            <div className="register_error_phone_btn">
              <div className="fl">
                <Link
                  onClick={() => {
                    window.location.href =
                      window.location.protocol +
                      "//" +
                      window.location.host +
                      "/?login_phone=" +
                      this.state.phone;
                  }}
                  to=""
                >
                  登 录
                </Link>
              </div>
              <div className="fr">
                <Link
                  onClick={() => this.handleClosePhoneModal()}
                  to="/user/register"
                >
                  更换手机号
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div
          style={
            this.state.error_visible === true
              ? { display: "block" }
              : { display: "none" }
          }
          className="register_error"
        >
          <div className="register_modal">
            <img
              alt=""
              src={require("../../../../images/user/notice.png")}
            ></img>
            <div className="register_error_info">
              <p>{this.state.error_info}</p>
            </div>
            <div
              style={
                this.state.error_btn === true
                  ? { display: "block" }
                  : { display: "none" }
              }
              onClick={() => this.handleCloseModal()}
              className="register_error_btn"
            >
              好 的
            </div>
          </div>
        </div>
        <YearSelect
          visible={this.state.ysVisible}
          selectYear={this.state.year}
          handleCloseYearSelect={this.handleCloseYearSelect}
          handleChangYear={this.handleChangYear.bind(this)}
        ></YearSelect>
        <Success
          visible={this.state.success_visible}
          text="注册成功！"
        ></Success>
        {/* 图形验证码弹窗 */}
        <div
          style={
            this.state.imgCodeVisible === true
              ? { display: "block" }
              : { display: "none" }
          }
          className="register_error"
        >
          <div className="register_modal imgcode_modal">
            <div className="imgcode_title">请输入图形验证码</div>
            <div className="imgcode_row">
              <img
                alt="图形验证码"
                src={this.state.imgCodeUrl}
                onClick={this.refreshImgCode}
                className="imgcode_img"
              />
              <span className="imgcode_tip">点击图片刷新</span>
            </div>
            <div className="imgcode_input_row">
              <input
                type="text"
                value={this.state.imgCode}
                onChange={this.handleImgCodeChang}
                placeholder="请输入图片中的内容"
                className="imgcode_input"
                maxLength={4}
              />
            </div>
            <div className="imgcode_btns">
              <div
                onClick={this.handleCancelImgCode}
                className="imgcode_btn_cancel"
              >
                取消
              </div>
              <div
                onClick={this.handleConfirmImgCode}
                className="imgcode_btn_confirm"
              >
                确认
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  /**
   * 开启高考年份选择
   */
  handleShowYearSelect = () => {
    this.setState({
      ysVisible: true,
    });
  };
  /**
   * 关闭高考年份选择
   */
  handleCloseYearSelect = () => {
    this.setState({
      ysVisible: false,
    });
  };
  /**
   * 高考年份选择框修改高考年份
   * @param {int} year
   */
  handleChangYear = (year, visible) => {
    this.setState({
      year: year,
      ysVisible: visible,
    });
  };
  handlePhoneChang = (e) => {
    this.setState({
      phone: e.target.value,
    });
  };
  handleCodeChang = (e) => {
    this.setState({
      code: e.target.value,
    });
  };
  handlePasswordChang = (e) => {
    this.setState({
      password: e.target.value,
    });
  };
  /**
   * 关闭通用的显示框
   */
  handleCloseModal = () => {
    this.setState({
      error_visible: false,
    });
  };
  /**
   * 关闭手机已注册错误modal框
   */
  handleClosePhoneModal = () => {
    this.setState({
      error_phone_visible: false,
      phone: "",
    });
  };
  /**
   * 倒计时60s
   */
  count = () => {
    let { yztime } = this.state;
    let time;
    this._smsInterval = setInterval(() => {
      time = yztime--;
      this.setState(
        { yztime: time, code_name: time + "秒后重新获取", loading: true },
        () => {
          if (yztime <= -1) {
            clearInterval(this._smsInterval);
            this.setState({
              loading: false,
              yztime: 59,
              code_name: "获取验证码",
              code_disabled: false,
            });
          }
        }
      );
    }, 1000);
  };
  /**
   * 请求短信
   */
  requestSms = () => {
    if (this.state.phone === "") {
      this.setState({
        error_visible: true,
        error_info: "手机号不能为空",
      });
      return;
    }
    if (!(this.state.phone.length === 11 && this.state.phone[0] === "1")) {
      this.setState({
        error_visible: true,
        error_info: "手机号有误",
      });
      return;
    }
    if (this.state.yztime === 59) {
      // 先弹出图形验证码弹窗
      this.setState({
        imgCode: "",
        imgCodeUrl: "/public/v1/user/imgCode?t=" + new Date().getTime(),
        imgCodeVisible: true,
      });
    }
  };
  /**
   * 图形验证码输入变化
   */
  handleImgCodeChang = (e) => {
    this.setState({ imgCode: e.target.value });
  };
  /**
   * 刷新图形验证码
   */
  refreshImgCode = () => {
    this.setState({
      imgCodeUrl: "/public/v1/user/imgCode?t=" + new Date().getTime(),
      imgCode: "",
    });
  };
  /**
   * 取消图形验证码弹窗
   */
  handleCancelImgCode = () => {
    this.setState({ imgCodeVisible: false, imgCode: "" });
  };
  /**
   * 确认图形验证码，发起短信请求
   */
  handleConfirmImgCode = () => {
    if (this.state.imgCode === "") {
      this.setState({
        error_visible: true,
        error_info: "图形验证码不能为空",
        imgCodeVisible: false,
      });
      return;
    }
    let params = { phone: this.state.phone, type: 1, imgCode: this.state.imgCode };
    get("/public/v1/user/phone/" + params.phone).then((res) => {
      if (res.status === "fail") {
        this.setState({
          error_phone_visible: true,
          imgCodeVisible: false,
        });
      } else {
        this.setState({ imgCodeVisible: false });
        this.count();
        post("/public/v1/user/sms", params).then((res) => {
          if (res.status === "fail") {
            // 短信发送失败（图形验证码错误等），重置倒计时
            clearInterval(this._smsInterval);
            this.setState({
              loading: false,
              yztime: 59,
              code_name: "获取验证码",
              error_visible: true,
              error_info: res.data.err_msg,
            });
          }
        });
      }
    });
  };
  /**
   * 请求注册
   */
  requestRegister = () => {
    let params = { phone: "", code: "", type: 1, password: "", year: "" };
    params.phone = this.state.phone;
    params.code = this.state.code;
    params.password = this.state.password;
    params.year = this.state.year;
    if (params.phone === "") {
      this.setState({
        error_visible: true,
        error_info: "手机号不能为空",
      });
      return;
    }
    if (params.code === "") {
      this.setState({
        error_visible: true,
        error_info: "验证码不能为空",
      });
      return;
    }
    if (params.password === "") {
      this.setState({
        error_visible: true,
        error_info: "密码不能为空",
      });
      return;
    }
    if (params.password.length < 6 || params.password.length > 18) {
      this.setState({
        error_visible: true,
        error_info: "请输入新密码（6-18位）",
      });
      return;
    }
    if (params.year === "") {
      this.setState({
        error_visible: true,
        error_info: "高考年份不能为空",
      });
      return;
    }
    post("/public/v1/user/register", params).then((res) => {
      if (res.status === "fail") {
        if (res.data.err_msg === "该手机号已注册") {
          this.setState({
            error_phone_visible: true,
          });
        } else {
          this.setState({
            error_visible: true,
            error_info: res.data.err_msg,
            code: "",
          });
        }
      } else {
        if (res.status === "success") {
          const { dispatch } = this.props;
          let userInfo = {
            phone: res.data.phone,
            year: res.data.year,
            isActive: res.data.isActive,
            isLogin: true,
            isBuy: res.data.isBuy,
            discounts: res.data.discounts,
          };
          dispatch(userActions.setUserInfo(userInfo));
          dispatch(userActions.setUserState("我的"));
          dispatch(userActions.setUserLink("/my"));
          if (res.data.isBuy) {
            dispatch(userActions.setUserDayUpLink("/dayup"));
          }
          this.setState({
            success_visible: true,
          });
          setTimeout(() => {
            window.location.href =
              window.location.protocol +
              "//" +
              window.location.host +
              "/?login_phone=" +
              this.state.phone;
          }, 1000);
        }
      }
    });
  };
}
const mapStateToProps = (state) => {
  return {
    userInfo: state.user.userData.userInfo,
  };
};
export default connect(mapStateToProps)(Register);



// WEBPACK FOOTER //
// ./src/containers/User/components/Register/index.js